import { useParams, useRoutes } from 'react-router';
import ChangeProduct from './product/ChangeProduct';

function ProductDetails() {
  const { id } = useParams();
  if (id) {
    return <ChangeProduct id={id} />;
  }

  return <ChangeProduct />;
}

export default ProductDetails;
